import { style } from 'styled-system';

export const offset = style({
  prop: 'offset',
  alias: 'columnOffset',
  cssProperty: 'marginLeft',
  transformValue: (n: number) => (n ? `${n * (100 / 24)}%` : 0),
});
